import {h, Fragment} from "preact"
export default function Checkbox({ value, selected, onChange, className, count }) {
    return (
        <label className={`ns-checkbox ns-color-checkbox ns-d-flex ${className}`}>
            <input type="checkbox" checked={selected} onChange={onChange} />
            {value != 'prints' ?
                (<span className={`ns-checkmark ns-checkmark-${value}`} style={`background-color:${value}`} />)
                : (<span className={`ns-checkmark ns-checkmark-${value}`} style="background-image:url('https://d21m4dsqdd3b9h.cloudfront.net/shopify-2422898758/onsiteContent/17453918649810.22637829575430612')" />)
            }
            {value} ({count})
        </label>
    )
}